import { Field, useFormikContext } from 'formik';
import React from 'react';
import { FormErrorUI, FormLabelUI, InputUI } from '../../Interface';
import { Typography } from '@mui/material';

const ComplaintReportD4 = ({ disabled }) => {
  const { values, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-12 gap-x-4 items-center">
      <div className="col-span-12 md:col-span-2">
        <Typography sx={{ fontSize: '1.2rem' }}>5 "miért?" elemzés</Typography>
      </div>
      <div className="col-span-12 md:col-span-5">
        <Field
          type="text"
          name="why1"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 1?" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why1} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why1 && values.why1 !== '' }}
          multiline
          rows={2}
        />
        <Field
          type="text"
          name="why2"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 2?" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why2} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why2 && values.why2 !== '' }}
          multiline
          rows={2}
        />
        <Field
          type="text"
          name="why3"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 3?" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why3} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why3 && values.why3 !== '' }}
          multiline
          rows={2}
        />
        <Field
          type="text"
          name="why4"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 4?" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why4} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why4 && values.why4 !== '' }}
          multiline
          rows={2}
        />
        <Field
          type="text"
          name="why5"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 5?" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why5} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why5 && values.why5 !== '' }}
          multiline
          rows={2}
        />
      </div>
      <div className="col-span-12 md:col-span-5">
        <Field
          type="text"
          name="why1Answer"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 1 válasz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why1Answer} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why1Answer && values.why1Answer !== '' }}
          multiline
          rows={2}
        />
        <Field
          type="text"
          name="why2Answer"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 2 válasz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why2Answer} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why2Answer && values.why2Answer !== '' }}
          multiline
          rows={2}
        />
        <Field
          type="text"
          name="why3Answer"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 3 válasz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why3Answer} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why3Answer && values.why3Answer !== '' }}
          multiline
          rows={2}
        />
        <Field
          type="text"
          name="why4Answer"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 4 válasz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why4Answer} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why4Answer && values.why4Answer !== '' }}
          multiline
          rows={2}
        />
        <Field
          type="text"
          name="why5Answer"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Miért 5 válasz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.why5Answer} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.why5Answer && values.why5Answer !== '' }}
          multiline
          rows={2}
        />
      </div>
    </div>
  );
};

export default ComplaintReportD4;
